<template>
  <div class="tool-modal-memberkit d-flex flex-column gap-4">
    <snow-select
      v-model="form.product_id"
      id="product-select"
      label="Produto"
      :disabled="isEdit"
      :errors="errors.product_id"
      :options="products.map(({ id, name }) => ({ id, name }))"
      required
    />
    <snow-input
      v-model="form.token"
      id="token"
      label="Informe o token"
      :rules="rules.token"
    />
    <h5>
      Preencha um dos campos abaixo: ID Turma ou ID Assinatura
    </h5>
    <snow-input
      v-model="form.classroom"
      id="classroom"
      label="ID Turma"
      :rules="rules.classroom"
      @input="handleClassroomInput"
    />
    <snow-input
      v-model="form.membership_level_id"
      id="signature"
      label="ID Assinatura"
      :rules="rules.membership_level_id"
      @input="handleMembershipInput"
    />

    <div class="snow-submit-buttons mt-3">
      <snow-button
        size="lg"
        class="order-lg-0 order-1"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        :text="isEdit ? 'Salvar' : 'Integrar'"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
import { required } from "@/functions/validation";
export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(
        ["product_id", "token", "classroom", "membership_level_id"],
        this.integrationToEdit
      )
    };
  },

  methods: {
    handleClassroomInput(value) {
      if (value) {
        this.form.membership_level_id = null;
      }
    },

    handleMembershipInput(value) {
      if (value) {
        this.form.classroom = null;
      }
    }
  },

  computed: {
    isValid() {
      return (
        this.form.product_id &&
        this.form.token &&
        (this.form.classroom || this.form.membership_level_id)
      );
    },
    rules() {
      return {
        token: [required()]
      };
    }
  }
};
</script>
